/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

const createSignUpPageStyles = makeStyles(theme => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    maxWidth: '390px',
    marginTop: theme.spacing(1),
    color: '#FFFFFF',
  },
  formFooter: {
    alignItems: 'center',
  },
  forgotStyle: {
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  formTitle: {
    color: theme.palette.primary.main,
    textAlign: 'center',
    paddingBottom: '0.3rem',
    fontSize: '1.6rem',
  },
  formGroup: {
    marginBottom: '0.2rem',
    minHeight: '66px',
  },
  errorBlock: {
    marginTop: '10px',
    marginBottom: '5px',
  },
  errorLine: {
    color: theme.palette.error.main,
    margin: '2px 0px',
    marginLeft: '1.8rem',
  },
}));
export { createSignUpPageStyles };
